<script>
    import {Doughnut} from 'vue-chartjs'

    export default {
        extends: Doughnut,
        mounted() {
            this.renderChart({
                labels: ['Reciclado', 'No Reciclado'],
                datasets: [
                    {
                        backgroundColor: [
                            '#40b800',
                            '#e4000f'
                        ],
                        data: [14, 86]
                    }
                ]
            }, {responsive: true, maintainAspectRatio: true})
        }
    }
</script>
